import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const UpdateTenantProfile = createAsyncThunk(
  "tenantProfile/UpdateTenantProfile",
  async (updateData, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token");
      let response = await axios.put(
        `${BASE_URL}/tenant-profile/update`,
        updateData,
        {
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Failed to update profile" });
    }
  }
);

// Asks the server what saving this edit would do to the tenant's open requests
// and paid bookings — without saving anything. Deliberately not wired into the
// slice: a dry run is not an update, so it must not flip `success`/`loading`.
export const PreviewTenantProfileUpdate = createAsyncThunk(
  "tenantProfile/PreviewTenantProfileUpdate",
  async (updateData, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token");
      const response = await axios.put(
        `${BASE_URL}/tenant-profile/update`,
        { ...updateData, dryRun: true },
        {
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to check your profile changes" }
      );
    }
  }
);

const UpdateTenantProfileSlice = createSlice({
  name: "updateTenantProfile",
  initialState: {
    loading: false,
    success: false,
    error: "",
  },
  reducers: {
    resetUpdateState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UpdateTenantProfile.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = "";
      })
      .addCase(UpdateTenantProfile.fulfilled, (state, action) => {
        state.success = true;
        state.loading = false;
      })
      .addCase(UpdateTenantProfile.rejected, (state, action) => {
        state.error = action.payload?.message || "Failed to update profile";
        state.loading = false;
        state.success = false;
      });
  },
});

export const { resetUpdateState } = UpdateTenantProfileSlice.actions;
export default UpdateTenantProfileSlice.reducer;
